<mat-card appearance="outlined">
    <app-transformer-top-header [isReadOnly]="isReadOnly" [viewModel]="viewModel" [transformslists]="transformslists" [iconpath]="iconpath" [nodeColor]="nodeColor" [transformNameType]="transformNameType" [aboutlink]="aboutlink"
    [refineryConfigGuid]="refineryConfigGuid" [refineryName]="refineryName" [nodeName]="nodeName" [nodeIndex]="nodeIndex" [configGuid]="configGuid" [cacheStatus]="cacheStatus" (onRefreshCacheStatus)="getCacheStatus()" (onPurgeCache)="purgeCache()"
    (onTransformTextChanged)="onTransformTextChanged()" 
    (onViewTransformConfigJson)="viewTransformConfigJson()" 
    (onRunTransform)="onRunTransformValidate()" 
    (onSaveConfig)="saveConfig()" (onShowTransformDetail)="showTransformDetail($event)" (onImportTransformer)="loadImportTransformer($event)" [hasResetSupport]="true" (onResetTransform)="resetTransformer()"
    [inputCacheKey]="copilotInputCacheKey"
    [sourceColumn]="columnCalcAvailableSourceFields[0] ?? ''"
    [availableSourceFields]="columnCalcAvailableSourceFields"
    [currentSampleStart]="viewModel?.parameters?.sampleStart ?? 0"
    [currentSampleEnd]="viewModel?.parameters?.sampleEnd ?? 0"
    (onApplySmartSample)="applySmartSample($event)"></app-transformer-top-header>

    <mat-card-content class="content-with-fixed-header">
        <!-- Description -->
        <mat-expansion-panel class="mat-elevation-z0" style="margin-top:5px;">
            <mat-expansion-panel-header>Description</mat-expansion-panel-header>
            <app-transformer-description [analystDescription]="viewModel.transform.analystDescription"
                (analystDescriptionChange)="viewModel.transform.analystDescription = $event"></app-transformer-description>
        </mat-expansion-panel>
        <!-- Parameters -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="margin-top:5px;">
            <mat-expansion-panel-header>Parameters<span *ngIf="isValidateParameters" class="mat-error" style="margin-left: 5px;">Missing Required Fields</span></mat-expansion-panel-header>
           <div style="margin-top:-10px;margin-left: -3px;">
            <app-transformer-parameters [viewModel]="viewModel.parameters" [sourceColumns]="viewModel.sourceColumnsDT" 
                (SetDefaultRule)="onSetDefaultRule($event)" 
                (ToggleRulesColumnDisplay)="onToggleRulesColumnDisplay()" 
                (formStatus)="onParameterFormStatusChange($event)"></app-transformer-parameters>
            </div>
        </mat-expansion-panel>
        <!-- Advanced Settings -->

        <!-- Rules -->
        <mat-expansion-panel class="mat-elevation-z0" expanded style="padding-top: 10px;">
            <mat-expansion-panel-header>
                <div style="display: flex; align-items: center; justify-content: center;">
                    <span style="margin-right: 30px;">Rules</span>
                    <button class="add-rule-btn"  style="margin-right: 8px;"
                        color="primary" mat-raised-button (click)="$event.stopPropagation(); addNewRule()"
                        title="Add new rule" style="height: 24px;border-radius: 2px;">
                        <mat-icon >add_circle</mat-icon>
                        ADD RULE
                    </button>

                    <button (click)="$event.stopPropagation(); toggleRulesHeight();"
                       class="rule-toggle-btn" mat-raised-button color="primary"
                         title="Show All" style=" line-height: 24px;height: 24px;border-radius: 2px;">
                        <mat-icon style="font-size: 20px;margin-right:0px">{{isRulesMaximized ? 'unfold_less' : 'unfold_more'}}
                        </mat-icon>
                    </button>
                </div>
            </mat-expansion-panel-header>
            <div style="margin-top: 0px; margin-left: -6px; margin-right: -6px; padding-left: 2px; padding-right: 2px;" class="show-scrollbar"
                appMatTableAdjustRowHeight [RowCount]="isRulesMaximized ? maxrowcount : minrowcount" [MaxRowCount]="maxrowcount" [IsScrollBottom]="isScrollBottom">
                <h1 class="center" style=" color: lightgray" *ngIf="isRuleSetEmpty">No Rules</h1>

                <table *ngIf="!isRuleSetEmpty" (cdkDropListDropped)="dropTable($event)" mat-table
                    [dataSource]="dataSource" #table class="drag-list mat-elevation-z8" cdkDropList
                    [cdkDropListData]="dataSource">

                    <ng-container matColumnDef="actions">
                        <th mat-header-cell *matHeaderCellDef class="no-padding-cell"> </th>
                        <td mat-cell *matCellDef="let rule" class="no-padding-cell">
                            <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center">
                                <mat-icon color="primary"
                                    style="cursor: grab" 
                                    cdkDrag [cdkDragData]="rule"
                                    cdkDragRootElement=".drag-component"
                                    cdkDragHandle
                                    matTooltip="Re-order Rule"  
                                    matTooltipPosition="below"
                                    #reorderTooltip="matTooltip"
                                    (mouseenter)="reorderTooltip.show()"
                                    (mouseleave)="reorderTooltip.hide()">
                                    reorder
                                </mat-icon>
                                <mat-icon style="margin-left: 4px; cursor: pointer" 
                                    class="icon" 
                                    (click)="onDuplicateRule(rule)" 
                                    matTooltip="Duplicate Rule" 
                                    matTooltipPosition="below"
                                    #duplicateTooltip="matTooltip"
                                    (mouseenter)="duplicateTooltip.show(); 
                                    reorderTooltip.hide()"
                                    (mouseleave)="duplicateTooltip.hide()"
                                    color="primary">
                                    control_point_duplicate
                                </mat-icon>
                                <mat-icon style="margin-left: 2px; cursor: pointer"
                                    (click)="onDeleteRule(rule)" 
                                    matTooltip="Delete Rule" 
                                    matTooltipPosition="below"
                                    #deleteTooltip="matTooltip"
                                    (mouseenter)="deleteTooltip.show(); duplicateTooltip.hide(); reorderTooltip.hide()"
                                    (mouseleave)="deleteTooltip.hide()"
                                    class="red-icon">
                                    delete_forever
                                </mat-icon>
                            </div>
                    </ng-container>

                    <ng-container matColumnDef="index">
                        <th mat-header-cell *matHeaderCellDef> Rule </th>
                        <td mat-cell *matCellDef="let rule"> {{rule.index}} </td>
                        <mat-icon cdkDragHandle>reorder</mat-icon>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef> Rule Name </th>
                        <td mat-cell *matCellDef="let rule"><input type="text"
                                style="border: none; box-sizing: border-box" [(ngModel)]="rule.name" appAutowidth>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="targetDataType">
                        <th mat-header-cell *matHeaderCellDef> Target DataType </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [(ngModel)]="rule.targetDataType" (selectionChange)="onTargetDataTypeChange(rule)">
                                <mat-option *ngFor="let option of viewModel.targetDataTypes" [value]="option.value">{{
                                    option.text }}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="targetField">
                        <th mat-header-cell *matHeaderCellDef> Target Field</th>
                        <td mat-cell *matCellDef="let rule" style="width: 20px;">
                            <div [matTooltip]="rule.tooltipMessageTargetField" matTooltipPosition="right" 
                                [matTooltipClass]="rule.tooltipTypeTargetField === 'red' ? 'warning-tooltip-red' : ''"
                                [matTooltipDisabled]="!rule.tooltipMessageTargetField"
                                [ngStyle]="getTooltipStyleTargetField(rule)">
                                    <app-autocomplete-field 
                                        [options]="rule.targetFarmColumns"    
                                        placeholder="Target Field" 
                                        [(ngModel)]="rule.targetField">
                                    </app-autocomplete-field>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="expression">
                        <th mat-header-cell style="color: #99ff00;" *matHeaderCellDef> Expression </th>
                        <td mat-cell *matCellDef="let rule" matTooltip="{{rule.expression}}" [matTooltipDisabled]="!rule.expression || rule.expression.length <= 50">
                            <div [matTooltip]="rule.tooltipMessageExpression" matTooltipPosition="right" 
                                [matTooltipClass]="rule.tooltipTypeExpression === 'red' ? 'warning-tooltip-red' : ''"
                                [matTooltipDisabled]="!rule.tooltipMessageExpression"
                                [ngStyle]="getTooltipStyleExpression(rule)">
                                    <div style="cursor: pointer" class="fixed-width-column text-overflow" (click)="onRuleExpressionCellClicked(rule)">
                                        <span *ngIf="rule.expression === ''"
                                            style="margin-left: 2px; margin-right: 2px; color: #99ff00; font-size:10px; white-space: pre;">Tap to Edit</span>
                                        <span
                                            style="margin-left:2px;margin-right:2px;white-space:pre;"
                                            [innerHTML]="getExpressionSafeHtml(rule.expression)">
                                        </span>
                                    </div>
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="ifError">
                        <th style="color: orange" mat-header-cell *matHeaderCellDef> If Error </th>
                        <td mat-cell *matCellDef="let rule" class="auto-width">
                            <mat-select [(ngModel)]="rule.ifError">
                                <mat-option></mat-option>
                                <mat-option *ngFor="let option of viewModel.ifErrorTypes" [value]="option.value">
                                    {{option.text}}
                                </mat-option>
                            </mat-select>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="isEnabled">
                        <th mat-header-cell *matHeaderCellDef>  <span style="margin-bottom: 2px; text-align: left;width: 40px;margin-right: 10px;">Run?</span> <mat-slide-toggle (change)="onRunChanged($event)"
                                color="primary"></mat-slide-toggle>
                        </th>
                        <td mat-cell *matCellDef="let rule"style="text-align: right;width: 40px;">
                            <mat-slide-toggle color="primary" [(ngModel)]="rule.run"></mat-slide-toggle>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="result">
                        <th mat-header-cell *matHeaderCellDef> Result </th>
                        <td mat-cell *matCellDef="let rule"> 
                            <span [ngClass]="{'result-failed': rule.result === 'Failed', 'result-success': rule.result === 'Success!'}">
                                {{rule.result}}
                            </span>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="details">
                        <th mat-header-cell *matHeaderCellDef> Details </th>
                        <td mat-cell *matCellDef="let rule" matTooltip="{{rule.details}}" [matTooltipDisabled]="!rule.details || rule.details.length <= 50" class="no-wrap-cell"> 
                            {{ rule.details?.length > 50 ? (rule.details | slice:0:50) + '...' : rule.details }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
                    <tr
                        class="drag-component"
                        mat-row
                        *matRowDef="let row; columns: displayedColumns;"
                        (click)="onRowClicked($event, row)"
                        [ngClass]="{'highlight-row': selectedRows.includes(row)}">
                    </tr>
                    <div *cdkDragPlaceholder></div>
                </table>
            </div>
        </mat-expansion-panel>
        <!-- Results Dashboard -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isResultsPanelExpanded">
            <mat-expansion-panel-header (click)="setActivityNamerResultsTabClicked()">Results Dashboard</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" [(selectedIndex)]="resultsDashboardTabIndex">
                <mat-tab label="Results">
                    <div style="position: relative">
                        <!-- <div style="position: absolute;left:200px;top: 4px; ">
                            <mat-form-field style="width: 120px" appearance="outline">
                                <mat-label>Farm Rows</mat-label>
                                <input readonly matInput placeholder="Rows" type="text" [value]="viewModel.rows | number">
                            </mat-form-field>
                            <mat-form-field style="width: 110px; margin-left: 3px;" appearance="outline">
                                <mat-label>Group Hits</mat-label>
                                <input type="text" readonly matInput placeholder="Hits"
                                    [value]="viewModel.groupHitCount | number">
                            </mat-form-field>
                            <mat-form-field style="width: 92px; margin-left: 3px;" appearance="outline">
                                <mat-label>Row Hits</mat-label>
                                <input type="text" readonly matInput placeholder="Hits" [value]="viewModel.hitCount | number">
                            </mat-form-field>
                            <mat-form-field style="width: 130px; margin-left: 3px;" appearance="outline">
                                <mat-label>Row Hit Ratio</mat-label>
                                <input type="text" readonly matInput placeholder="Row Hit Ratio"
                                    [(ngModel)]="viewModel.hitRatioDisplay">
                            </mat-form-field>
                            <mat-form-field style="width: 90px; margin-left: 3px;" appearance="outline">
                                <mat-label>Misses</mat-label>
                                <input type="text" readonly matInput placeholder="Misses"
                                    [value]="viewModel.missCount | number">
                            </mat-form-field>
                        </div> -->
                        <div style="position: absolute;left:200px;top: 4px; ">
                            <mat-form-field *ngIf="lastDtrRunTime" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>Uncompiled</mat-label>
                                <input type="text" readonly matInput [value]="lastDtrRunTime"
                                    matTooltip="Run Time (uncompiled) — time taken by the generic engine to execute this transform" matTooltipPosition="above">
                            </mat-form-field>
                            <mat-form-field *ngIf="lastDtrRunTime && isCompilable" style="width: 120px; margin-left: 3px;" appearance="outline">
                                <mat-label>When compiled</mat-label>
                                <input type="text" readonly matInput [value]="lastCompiledRunTime"
                                    matTooltip="Preview only — how fast the compiled fast-path engine would run this transform's CURRENT config (saved or not), not necessarily what production is using right now. Save to make this the actual compiled plan production runs. NA when the config isn't fully compilable or its own Run All Rows setting is off." matTooltipPosition="above">
                            </mat-form-field>
                        </div>
                        <app-preview-table [delegate]="this" #previewTable [hideRefresh]="true" [hideOptions]="true" previewType="temptransResult" previewTypeName="Result"
                            [viewModel]="previewDataViewModel"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Summary">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryResult" #menuTriggerResult="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilterResult(menuTriggerResult)">Summary Fields</button>
                    <span>{{ totalSummaryRowsResult }}</span>
                    <mat-menu #menusummaryResult="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesResult" [valuesColor]="selectValuesColorResult" [sources]="datafarmSourcesResult" [source]="sourceResult" [emptyColumns]="selectEmptyColumnsResult" [selectedColumns]="selectFilterValuesResult" columnName="Summary" (clearFilter)="onClearSelectResult($event)" (applyFilter)="onApplySelectResult($event)" (closeFilter)="onCloseSelectResult()"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableResult [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Preview -->
        <mat-expansion-panel class="mat-elevation-z0" [expanded]="isPreviewPanelExpanded">
            <mat-expansion-panel-header (click)="setActivityNamerPreviewTabClicked()">Data Farm Preview</mat-expansion-panel-header>
            <mat-tab-group animationDuration="300ms" (selectedTabChange)="onTabClick($event)">
                <mat-tab label="Input ({{inputcolumncount}})">
                    <div style="position: relative;">
                        <app-preview-table [delegate]="this" #inputDataFarmPreviewTable [hideRefresh]="true"
                            [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="transInput" previewTypeName="Input"  ></app-preview-table>
                    </div>
                </mat-tab>
                <mat-tab label="Output ({{outputcolumncount}})">
                    <app-preview-table [delegate]="this" #outputDataFarmPreviewTable [hideRefresh]="true"
                        [hideOptions]="true" [viewModel]="previewDataViewModel" previewType="temptransOutput" previewTypeName="Output"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Input)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryinput" #menuTriggerInput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerInput,'Input')">Summary Fields</button>
                    <span>{{ totalSummaryRowsInput }}</span>
                    <mat-menu #menusummaryinput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesInput" source="Input" [emptyColumns]="selectEmptyColumnsInput" [selectedColumns]="selectFilterValuesInput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableInput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
                <mat-tab label="Summary (Output)">
                    <button mat-raised-button color="primary" [matMenuTriggerFor]="menusummaryoutput" #menuTriggerOutput="matMenuTrigger"  style="margin-top: 3px;margin-left: 20px;margin-right: 50px;" (click)="showSelectFilter(menuTriggerOutput,'Output')">Summary Fields</button>
                    <span>{{ totalSummaryRowsOutput }}</span>
                    <mat-menu #menusummaryoutput="matMenu" yPosition="below" style="margin-top: 2% !important;">
                        <app-select-filter-option [values]="selectValuesOutput" source="Output" [emptyColumns]="selectEmptyColumnsOutput" [selectedColumns]="selectFilterValuesOutput" columnName="Summary" (clearFilter)="onClearSelect($event)" (applyFilter)="onApplySelect($event)" (closeFilter)="onCloseSelect()" (changeSource)="onChangeSource($event)"></app-select-filter-option>
                    </mat-menu>
                    <app-preview-table style="width: 100px;" [delegate]="this" #summaryDataFarmPreviewTableOutput [hideRefresh]="true" previewType="Summary" 
                        [hideOptions]="true" [viewModel]="previewDataViewModel" [widthOptions]="true"  ></app-preview-table>
                </mat-tab>
            </mat-tab-group>
        </mat-expansion-panel>
        <!-- Data Farm Export -->
        <mat-expansion-panel [disabled]="isDisabled" [expanded]="!isDisabled" class="mat-elevation-z0">
            <mat-expansion-panel-header (click)="DataFarmExport()">Data Farm Export</mat-expansion-panel-header>
            <app-export-output-data #exportOutputData [hideOptions]="true" 
            [viewModelExport]="viewModelExport"></app-export-output-data>
        </mat-expansion-panel>
    </mat-card-content>
</mat-card>